import axios from 'axios'
import Cookie from 'js-cookie'
import CryptoJS from 'crypto-js'

export const baseUrl = 'http://www.eisong.com:8080/' // 'http://152.68.21.17:8111/' // 'http://192.168.2.10:8111/' // 

// 附件
export const aliUrl = 'https://bwlover.oss-cn-hangzhou.aliyuncs.com/'

let appId = '8111'
let appKey = '8dbb71a37803a96e287bae2819d9d9d8'

/**
 * 通用HTTP请求方法
 * 上传附件时使用此方法获取上传地址，isreturn必须为true
 * METHOD包含GET、POST
 */
export const httpRequest = (params, method = 'GET', isreturn) => {
    let paramsTrim = {}

    let timestamp = Math.round(new Date().getTime() / 1000)
    let paramSort = Object.keys(params).sort()
    let signStr = appId + appKey + timestamp
    let sp = ''
    let postUrl = baseUrl + '?action=' + params.action + '&app_id=' + appId + '&timestamp=' + timestamp
    let postParams = {}

    for (let i = 0; i < paramSort.length; i++) {
        if (params[paramSort[i]] != undefined) {
            signStr += sp + paramSort[i] + '=' + params[paramSort[i]]
            sp = '&'
            paramsTrim[paramSort[i]] = params[paramSort[i]]
        }
    }

    paramsTrim.app_id = appId
    paramsTrim.timestamp = timestamp
    paramsTrim.sign = CryptoJS.MD5(signStr).toString().toUpperCase()
    postUrl += '&sign=' + paramsTrim.sign
    if (isreturn) {
        let returnStr = baseUrl + '?'
        let sp = ''
        for (let key in paramsTrim) {
            returnStr += sp + key + '=' + paramsTrim[key]
            sp = '&'
        }
        return returnStr
    }

    // 登录参数
    let headers = {}
    let admin = getCookie('admin')
    if (admin['aid']) {
        headers['loginId'] = admin.aid
    }

    if (method == "GET") {
        return new Promise((resolve, reject) => {
            axios.get(baseUrl, {
                params: paramsTrim,
                headers: headers
            }).then((response) => {
                resolve(response.data)
            }).catch((error) => {
                resolve({
                    error: true,
                    msg: error
                })
            })
        })
    } else {
        // 去除放入地址栏中的参数
        delete paramsTrim.action
        delete paramsTrim.app_id
        delete paramsTrim.timestamp
        delete paramsTrim.sign
        return new Promise((resolve, reject) => {
            axios.post(postUrl, paramsTrim, {
                    headers: headers
                })
                .then(response => {
                    resolve(response.data);
                })
                .catch((error) => {
                    resolve({
                        error: true,
                        msg: error
                    })
                })
        })
    }
}

// 获取COOKIE
export const getCookie = (type) => {
    let cookiestr = Cookie.get(type)
    return cookiestr ? JSON.parse(aesDecrypt(cookiestr)) : {}
}
// 强密码验证
export const passwordCheck = value => {
    var arr = [],
        array = [1, 2, 3, 4, 5]
    if (value.length < 6) {
        //最初级别
        return 0
    }
    if (/\d/.test(value)) {
        //如果用户输入的密码 包含了数字
        arr.push(1)
    }
    if (/[a-z]/.test(value)) {
        //如果用户输入的密码 包含了小写的a到z
        arr.push(2)
    }
    if (/[A-Z]/.test(value)) {
        //如果用户输入的密码 包含了大写的A到Z
        arr.push(3)
    }
    if (/\W/.test(value)) {
        //如果是非数字 字母 下划线
        arr.push(4)
    }
    for (var i = 0; i < array.length; i++) {
        if (arr.indexOf(array[i]) == -1) {
            return array[i]
        }
    }
}

// 加密字符串
export const aesEncrypt = (codeString) => {
    var key = CryptoJS.enc.Utf8.parse(appKey);
    var srcs = CryptoJS.enc.Utf8.parse(codeString);
    var encrypted = CryptoJS.AES.encrypt(srcs, key, {
        iv: CryptoJS.enc.Utf8.parse('87abe96b2dba9799'),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.ZeroPadding
    })

    return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
}

// 解密字符串
export const aesDecrypt = (cipherText) => {
    let key = CryptoJS.enc.Utf8.parse(appKey)
    let iv = CryptoJS.enc.Utf8.parse('87abe96b2dba9799')
    // 返回的是一个Word Array Object，其实就是Java里的字节数组
    let decrypted = CryptoJS.AES.decrypt(cipherText, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.ZeroPadding
    })
    return decrypted.toString(CryptoJS.enc.Utf8)
}